"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openRenewModal = void 0;
exports.setRenewModal = setRenewModal;
let renewModal = null;
function setRenewModal(modal) {
    renewModal = modal;
}
// function clearRenewModal() {
// 	renewModal = null;
// }
const openRenewModal = (args = {}) => renewModal !== null ? renewModal.open(args) : Promise.reject();
exports.openRenewModal = openRenewModal;
//# sourceMappingURL=renewModal.js.map